import { forwardRef } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from '../lib/cn.js'
import { Campo } from './Campo.js'
import { Icone } from './Icone.js'

export type SelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  rotulo: string
  dica?: string | undefined
  erro?: string | undefined
  opcoes: { valor: string; rotulo: string; desabilitada?: boolean }[]
  placeholder?: string | undefined
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { rotulo, dica, erro, opcoes, placeholder, className, required, ...resto },
  ref,
) {
  return (
    <Campo rotulo={rotulo} dica={dica} erro={erro} obrigatorio={required}>
      {({ id, descritoPor, invalido }) => (
        <span className={cn('du-entrada du-entrada--select', className)}>
          <select
            ref={ref}
            id={id}
            aria-describedby={descritoPor}
            aria-invalid={invalido || undefined}
            required={required}
            {...resto}
          >
            {placeholder ? (
              <option value="" disabled>
                {placeholder}
              </option>
            ) : null}
            {opcoes.map((o) => (
              <option key={o.valor} value={o.valor} disabled={o.desabilitada}>
                {o.rotulo}
              </option>
            ))}
          </select>
          <Icone de={ChevronDown} tamanho={20} className="du-entrada__seta" />
        </span>
      )}
    </Campo>
  )
})
